/** Sync store so API helpers can send the visitor's chosen country. */
let publicCountryId: string | null = null;

export function setPublicCountryIdForApi(countryId: string | null) {
  publicCountryId = countryId;
}

export function getPublicCountryIdForApi(): string | null {
  return publicCountryId;
}
